module.exports = __webpack_public_path__ + "img/skills-berserker-barb-3.6b04c76a.png";